module.exports = __webpack_public_path__ + "img/ip.c36f9f9a.svg";